/* eslint-disable import/prefer-default-export */
import _ from 'lodash/fp'

export const keysToCamelCase = _.mapKeys(_.camelCase)
